import styled from "styled-components";
import { media } from "../../../../../components/common/media";

const TrendingTagsContainer = styled.div`
  text-align: center;
  padding-bottom: 60px;
  h2 {
    margin-bottom: 30px;
  }
  img {
    width: 100%;
    max-width: 180px;
    margin: 0 10px;
    border-radius: 10px;
  }
  .slide {
    background: transparent !important;
  }
  .flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    align-content: space-around;
    width: 100%;
    max-width: 1230px;
    margin: 40px auto 60px;
    .tags-container {
      position: relative;
      .hover-div {
        position: absolute;
        background: rgba(0, 0, 0, 0.2);
        transition: all 0.6s ease 0s;
        border-radius: 10px;
        max-width: 180px;
        margin: auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
      &:hover {
        .hover-div {
          background: rgba(0, 0, 0, 0.4);
        }
      }

      span {
        position: absolute;
        color: #fff;
        font-weight: 700;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        line-height: 80px;
        font-size: 20px;
      }
    }
    ${media.desktop`
      overflow-x: auto;
      flex-wrap: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
      a { 
        div  {
          width: 200px;
        }
      }
    `};
  }
`;

export default TrendingTagsContainer;
